module.exports = __webpack_public_path__ + "img/icon-thermo.2a08b930.svg";